import {handleActions} from 'redux-actions';

const initState = {};

const actions = {}

actions["AGENT_LOGIN_ACTION"] = (state, action) => {
    return {
        ...state,
        loginResult:action.payload
    }
};

export const agentLoginReducer = handleActions(actions, initState)
